var map = {
	"./asset-hyperlink.json": 981,
	"./blockquote.json": 982,
	"./document.json": 983,
	"./embedded-asset-block.json": 984,
	"./embedded-entry-block.json": 985,
	"./embedded-entry-inline.json": 986,
	"./embedded-resource-block.json": 987,
	"./embedded-resource-inline.json": 988,
	"./entry-hyperlink.json": 989,
	"./heading-1.json": 990,
	"./heading-2.json": 991,
	"./heading-3.json": 992,
	"./heading-4.json": 993,
	"./heading-5.json": 994,
	"./heading-6.json": 995,
	"./hr.json": 996,
	"./hyperlink.json": 997,
	"./list-item.json": 998,
	"./ordered-list.json": 999,
	"./paragraph.json": 1000,
	"./resource-hyperlink.json": 1001,
	"./table-cell.json": 1002,
	"./table-header-cell.json": 1003,
	"./table-row.json": 1004,
	"./table.json": 1005,
	"./text.json": 1006,
	"./unordered-list.json": 1007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;